// src/pages/ChangePasswordPage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Auth.css";

function ChangePasswordPage() {
  const navigate = useNavigate();
  const { user, updatePassword, isAuthenticated } = useAuth();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // 인증되지 않은 경우 로그인 페이지로 리다이렉트
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // 이미 비밀번호를 변경한 경우 메인 페이지로 리다이렉트
  useEffect(() => {
    if (user && user.password_changed) {
      if (user.role === "admin") {
        navigate("/admin", { replace: true });
      } else {
        navigate("/main", { replace: true });
      }
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // 유효성 검사
    if (!newPassword || !confirmPassword) {
      setError("새 비밀번호를 입력해주세요.");
      return;
    }

    if (newPassword.length < 6) {
      setError("비밀번호는 최소 6자 이상이어야 합니다.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("새 비밀번호가 일치하지 않습니다.");
      return;
    }

    if (newPassword === "password123") {
      setError("기존 임시 비밀번호와 동일한 비밀번호는 사용할 수 없습니다.");
      return;
    }

    setIsLoading(true);

    try {
      await updatePassword(newPassword);
      // 성공 시 메인 페이지로 리다이렉트
      if (user?.role === "admin") {
        navigate("/admin", { replace: true });
      } else {
        navigate("/main", { replace: true });
      }
    } catch (err) {
      setError(err.message || "비밀번호 변경 중 오류가 발생했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  // 인증되지 않았거나 로딩 중이면 아무것도 표시하지 않음
  if (!isAuthenticated || !user || user.password_changed) {
    return null;
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-left">
          <h1 className="portal-title">비밀번호 변경</h1>
          <p className="portal-desc">
            보안을 위해 최초 로그인 시 비밀번호를 변경해주세요.
          </p>
        </div>

        <div className="auth-right">
          <h2 className="auth-section-title">비밀번호 변경 필수</h2>
          <p className="auth-section-desc">
            최초 로그인 시 비밀번호를 변경해야 합니다.
            <br />
            안전한 비밀번호를 설정해주세요.
          </p>

          <form className="auth-form" onSubmit={handleSubmit}>
            <label className="auth-label">
              새 비밀번호
              <input
                type="password"
                className="auth-input"
                placeholder="새 비밀번호를 입력하세요 (최소 6자)"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={6}
              />
            </label>

            <label className="auth-label">
              새 비밀번호 확인
              <input
                type="password"
                className="auth-input"
                placeholder="새 비밀번호를 다시 입력하세요"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
              />
            </label>

            {error && <div className="auth-error">{error}</div>}

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={isLoading}
            >
              {isLoading ? "변경 중..." : "비밀번호 변경"}
            </button>
          </form>

          <div className="auth-footer" style={{ marginTop: "16px" }}>
            <p style={{ fontSize: "12px", color: "#6b7280" }}>
              ⚠️ 비밀번호를 변경하지 않으면 다른 페이지에 접근할 수 없습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordPage;
